module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.open) ? _c('div', {
    class: [
      "tooltip",
      ("tooltip--" + _vm.level)
    ]
  }, [_c('div', {
    staticClass: "tooltip__close"
  }, [(_vm.close) ? _c('module-icon', {
    attrs: {
      "icon": "close"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeTooltip()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tooltip__wrapper"
  }, [(_vm.tipIcon) ? _c('module-icon', {
    attrs: {
      "icon": _vm.tipIcon
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.tipIcon ? 'ml' : '']
  }, [_vm._t("message")], 2)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019ec19c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Tooltip.vue
// module id = 112
// module chunks = 3